import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import {
  getDrawingLogListAction,
  handleLoadingAction,
} from "../../../store/actions/DrawingActions";
import TableLoaderEffect from "../../constant/TableLoader";
import Pagination from "../../constant/Pagination";
import { Spinner, Modal } from "react-bootstrap";

const LogListPage = (props) => {
  const { logList, logCount, isLogListLoading, isLogSearchQueryLoading } =
    props;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const recordsPage = 10;
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(handleLoadingAction({ isLogListLoading: true }));
    dispatch(handleLoadingAction({ isReviseFileUpload: false }));
  }, []);

  useEffect(() => {
    dispatch(
      getDrawingLogListAction(id, currentPage, recordsPage, searchQuery)
    );
  }, [currentPage, searchQuery, id]);

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (value) {
      dispatch(handleLoadingAction({ isLogSearchQueryLoading: true }));
    }
    setCurrentPage(1);
    setSearchQuery(value);
  };

  const toggleModal = (details = null) => {
    setSelectedLog(details)
    setShowModal(!showModal);
  };


  const handlePagination = (page) => {
    const new_page = page.selected + 1;
    setCurrentPage(new_page);
  };

  return (
    <>
      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
        <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
          <h4 className="heading mb-0 fw-bold">Log List</h4>
          <div className="d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
            <div className="me-3 mb-3 mb-md-0">
              <div className="input-group tp-input-group">
                <input
                  type="text"
                  name="search"
                  style={{ minWidth: "15rem" }}
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="form-control form-control-sm"
                  placeholder="Search"
                />
                <div className="input-group-text" id="basic-search">
                  {isLogSearchQueryLoading && (
                    <Spinner variant="primary" size="sm" />
                  )}
                  {!isLogSearchQueryLoading && searchQuery.length > 0 ? (
                    <i
                      className="fa-solid fa-xmark c-pointer text-primary"
                      onClick={() => {
                        setCurrentPage(1);
                        setSearchQuery("");
                      }}
                    ></i>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="empoloyees-tblwrapper"
            className="table ItemsCheckboxSec dataTable no-footer mb-0"
          >
            <thead>
              <tr>
                <th>Log</th>
                <th>Message</th>
                <th>User</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {isLogListLoading ? (
                <TableLoaderEffect colLength={4} />
              ) : (
                logList.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <span
                        className="text-primary cursor-pointer fw-bolder"
                        onClick={()=>toggleModal(item)}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>{item.message}</td>
                    <td>{item.user.full_name}</td>
                    <td>{item.action_time}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isLogListLoading ? (
        <div style={{ height: "4rem" }}></div>
      ) : (
        <Pagination
          currentPage={currentPage}
          recordsPage={recordsPage}
          dataLength={logCount}
          handlePagination={handlePagination}
        />
      )}

      <Modal
        className="modal fade"
        id="exampleModal1"
        show={showModal}
        onHide={toggleModal}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">
              Log Details
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={toggleModal}
            ></button>
          </div>
          <div className="modal-body">
          {selectedLog && selectedLog.details && selectedLog.details.split('|').map((detail, index) => (
            <div className="mb-3" key={index}>{detail}</div>
          ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => { 
  return {
    logList: state.drawing.drawingLogList,
    logCount: state.drawing.drawingLogCount,
    isLogListLoading: state.drawing.isDrawingLogListLoading,
    isLogSearchQueryLoading: state.drawing.isLogSearchQueryLoading,
  };
};

export default connect(mapStateToProps)(LogListPage);
